import DialogContentText from "@material-ui/core/DialogContentText";
import ActionDialog from "@saleor/components/ActionDialog";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface RotaryItemDeleteDialogProps {
  rotaryName: string;
  confirmButtonState: ConfirmButtonTransitionState;
  open: boolean;
  text: string;
  useName?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const RotaryItemDeleteDialog: React.FC<RotaryItemDeleteDialogProps> = ({
  rotaryName,
  text,
  confirmButtonState,
  useName,
  onClose,
  onConfirm,
  open
}) => {
  const intl = useIntl();

  return (
    <ActionDialog
      open={open}
      onClose={onClose}
      confirmButtonState={confirmButtonState}
      onConfirm={onConfirm}
      variant="delete"
      title={intl.formatMessage({
        defaultMessage: "Delete rotary item",
        description: "dialog title"
      })}
    >
      <DialogContentText>
        {useName ? (
          <FormattedMessage
            defaultMessage='Are you sure you want to delete "{text}" item? If you delete it you won’t be able to assign it to any of the products with "{rotaryName}" rotary.'
            values={{
              rotaryName,
              text
            }}
          />
        ) : (
          <FormattedMessage
            defaultMessage='Are you sure you want to delete "{text}" item?'
            description="delete attribute value"
            values={{
              text
            }}
          />
        )}
      </DialogContentText>
    </ActionDialog>
  );
};
export default RotaryItemDeleteDialog;
